// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-dropdown {
  position: relative;
  width: 100%;
}

.screener-dropdown__toggle.MuiButton-root {
  padding: 7px 12px 7px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--input-border);
  border-radius: 4px;
  text-transform: none;

  &:hover {
    border: 1px solid var(--border-primary-brand);
    background-color: inherit;
  }
}

.screener-dropdown__toggle--small.MuiButton-root {
  width: 100%;
}

.screener-dropdown__toggle--large.MuiButton-root {
  width: 100%;
}

.screener-dropdown__toggle-text.MuiTypography-root {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.screener-dropdown__toggle-text--placeholder.MuiTypography-root {
  color: var(--text-secondary);
}

.screener-dropdown__arrow {
  width: 16px;
  height: 16px;
  path {
    fill: var(--accent-primary);
  }
}

.screener-dropdown__arrow--open {
  transform: rotate(180deg);
}

.screener-dropdown__content {
  position: absolute;
  top: 100%;
  left: 0;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  width: 100%;
  max-height: 480px;
  overflow-y: auto;
  background-color: var(--surface-primary);
  padding: 8px 0px;
  box-shadow: 0 0 12px 0 var(--box-shadow-primary);
  z-index: 1000;
  margin-top: 4px;
  scrollbar-width: thin;
  scrollbar-color: var(--surface-disabled) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--surface-disabled);
    border-radius: 3px;
  }
}

.screener-dropdown__header {
  box-sizing: border-box;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  justify-content: space-between;
  background-color: var(--surface-senary);
}

.screener-dropdown__header--presets {
  margin-top: 8px;
}

.screener-dropdown__empty-text.MuiTypography-root {
  box-sizing: border-box;
  padding: 12px 24px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 14px;
  line-height: 20px;
  color: var(--text-secondary);
}

.screener-dropdown__header-title.MuiTypography-root {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--text-subheader);
}

.screener-dropdown__header-btn.MuiButton-root {
  box-sizing: border-box;
  min-width: 0px;
  padding: 0px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--text-subheader);
  text-decoration: underline;
  text-transform: none;
  &:hover {
    background-color: var(--tab-filter-off-surface2);
  }
}

.screener-dropdown__item {
  box-sizing: border-box;
  width: 100%;
  padding: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.screener-dropdown__item--active {
  background: var(--color-brand-hover);
}

.screener-dropdown__item:hover {
  background: var(--color-brand-hover2);
}

.screener-dropdown__item:hover .screener-dropdown__delete-btn {
  opacity: 1;
}

.screener-dropdown__preset-list {
  display: flex;
  flex-direction: column;
}

.screener-dropdown__item-btn.MuiButton-root {
  box-sizing: border-box;
  min-height: 48px;
  padding: 8px 12px 8px 16px;
  flex: 1;
  justify-content: start;
  text-align: left;
  cursor: pointer;
  text-transform: none;
  color: var(--text-primary);
  background: transparent;
}

.screener-dropdown__item-btn.MuiButton-root:disabled {
  color: var(--text-secondary);
}

.screener-dropdown__item-btn.MuiButton-root:hover {
  background: transparent;
}

.screener-dropdown__item-text.MuiTypography-root {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  white-space: pre-wrap;
}

.screener-dropdown__delete-btn.MuiButton-root {
  padding: 0px;
  min-width: 0px;
  margin-right: 24px;
  justify-content: end;
  background-color: transparent;
  border: none;
  cursor: pointer;
  opacity: 0;
  transition: opacity 150ms ease;
}

.screener-dropdown__delete-btn--visible.MuiButton-root {
  opacity: 1;
}

.screener-dropdown__delete-icon {
  width: 20px;
  height: 20px;
}

.screener-dropdown__delete-icon path {
  fill: var(--color-brand);
}

.screener-dropdown__mobile-overlay {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-primary);
}

.screener-dropdown__mobile-header {
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  flex-shrink: 0;
  padding: 16px;
  border-bottom: 1px solid var(--border-primary, #bdbdbd);
}

.screener-dropdown__mobile-back.MuiIconButton-root {
  position: absolute;
  left: 16px;
  padding: 0px;

  & svg {
    width: 24px;
    height: 24px;
  }
}

.screener-dropdown__mobile-title.MuiTypography-root {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-subheader);
  text-align: center;
}

.screener-dropdown__mobile-body {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: var(--surface-disabled) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--surface-disabled);
    border-radius: 3px;
  }
}

.screener-dropdown__saved-list {
  display: flex;
  flex-direction: column;
}

.screener-dropdown__mobile-footer {
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 16px 24px;
  border-top: 1px solid var(--border-tertiary);
}

.screener-dropdown__mobile-cancel.MuiButton-root {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 4px;
  background-color: var(--surface-primary);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--color-brand);
  text-transform: none;
  box-shadow: none;
  &:hover {
    background: var(--color-brand-hover2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/ScreenerDropdown/ScreenerDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;;EAEpB;IACE,6CAA6C;IAC7C,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,oDAAoD;;EAEpD;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;EACpB;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;;EAEZ;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;;EAEpD;IACE,UAAU;EACZ;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".screener-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.screener-dropdown__toggle.MuiButton-root {\n  padding: 7px 12px 7px 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid var(--input-border);\n  border-radius: 4px;\n  text-transform: none;\n\n  &:hover {\n    border: 1px solid var(--border-primary-brand);\n    background-color: inherit;\n  }\n}\n\n.screener-dropdown__toggle--small.MuiButton-root {\n  width: 100%;\n}\n\n.screener-dropdown__toggle--large.MuiButton-root {\n  width: 100%;\n}\n\n.screener-dropdown__toggle-text.MuiTypography-root {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.screener-dropdown__toggle-text--placeholder.MuiTypography-root {\n  color: var(--text-secondary);\n}\n\n.screener-dropdown__arrow {\n  width: 16px;\n  height: 16px;\n  path {\n    fill: var(--accent-primary);\n  }\n}\n\n.screener-dropdown__arrow--open {\n  transform: rotate(180deg);\n}\n\n.screener-dropdown__content {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid var(--border-primary);\n  width: 100%;\n  max-height: 480px;\n  overflow-y: auto;\n  background-color: var(--surface-primary);\n  padding: 8px 0px;\n  box-shadow: 0 0 12px 0 var(--box-shadow-primary);\n  z-index: 1000;\n  margin-top: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--surface-disabled) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--surface-disabled);\n    border-radius: 3px;\n  }\n}\n\n.screener-dropdown__header {\n  box-sizing: border-box;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-align: left;\n  justify-content: space-between;\n  background-color: var(--surface-senary);\n}\n\n.screener-dropdown__header--presets {\n  margin-top: 8px;\n}\n\n.screener-dropdown__empty-text.MuiTypography-root {\n  box-sizing: border-box;\n  padding: 12px 24px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--text-secondary);\n}\n\n.screener-dropdown__header-title.MuiTypography-root {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: var(--text-subheader);\n}\n\n.screener-dropdown__header-btn.MuiButton-root {\n  box-sizing: border-box;\n  min-width: 0px;\n  padding: 0px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: var(--text-subheader);\n  text-decoration: underline;\n  text-transform: none;\n  &:hover {\n    background-color: var(--tab-filter-off-surface2);\n  }\n}\n\n.screener-dropdown__item {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.screener-dropdown__item--active {\n  background: var(--color-brand-hover);\n}\n\n.screener-dropdown__item:hover {\n  background: var(--color-brand-hover2);\n}\n\n.screener-dropdown__item:hover .screener-dropdown__delete-btn {\n  opacity: 1;\n}\n\n.screener-dropdown__preset-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.screener-dropdown__item-btn.MuiButton-root {\n  box-sizing: border-box;\n  min-height: 48px;\n  padding: 8px 12px 8px 16px;\n  flex: 1;\n  justify-content: start;\n  text-align: left;\n  cursor: pointer;\n  text-transform: none;\n  color: var(--text-primary);\n  background: transparent;\n}\n\n.screener-dropdown__item-btn.MuiButton-root:disabled {\n  color: var(--text-secondary);\n}\n\n.screener-dropdown__item-btn.MuiButton-root:hover {\n  background: transparent;\n}\n\n.screener-dropdown__item-text.MuiTypography-root {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  white-space: pre-wrap;\n}\n\n.screener-dropdown__delete-btn.MuiButton-root {\n  padding: 0px;\n  min-width: 0px;\n  margin-right: 24px;\n  justify-content: end;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 150ms ease;\n}\n\n.screener-dropdown__delete-btn--visible.MuiButton-root {\n  opacity: 1;\n}\n\n.screener-dropdown__delete-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.screener-dropdown__delete-icon path {\n  fill: var(--color-brand);\n}\n\n.screener-dropdown__mobile-overlay {\n  box-sizing: border-box;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--surface-primary);\n}\n\n.screener-dropdown__mobile-header {\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  flex-shrink: 0;\n  padding: 16px;\n  border-bottom: 1px solid var(--border-primary, #bdbdbd);\n}\n\n.screener-dropdown__mobile-back.MuiIconButton-root {\n  position: absolute;\n  left: 16px;\n  padding: 0px;\n\n  & svg {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.screener-dropdown__mobile-title.MuiTypography-root {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-subheader);\n  text-align: center;\n}\n\n.screener-dropdown__mobile-body {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 8px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--surface-disabled) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--surface-disabled);\n    border-radius: 3px;\n  }\n}\n\n.screener-dropdown__saved-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.screener-dropdown__mobile-footer {\n  box-sizing: border-box;\n  flex-shrink: 0;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-tertiary);\n}\n\n.screener-dropdown__mobile-cancel.MuiButton-root {\n  box-sizing: border-box;\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 4px;\n  background-color: var(--surface-primary);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--color-brand);\n  text-transform: none;\n  box-shadow: none;\n  &:hover {\n    background: var(--color-brand-hover2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
